import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-KDJLPGJ2RQ";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** Sends page views on client-side route changes; initial load is covered by index.html gtag. */
export function GoogleAnalytics() {
  const location = useLocation();
  const isFirstNavigation = useRef(true);

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    if (isFirstNavigation.current) {
      isFirstNavigation.current = false;
      return;
    }

    const pagePath =
      window.location.pathname +
      window.location.search +
      window.location.hash;

    window.gtag("config", GA_MEASUREMENT_ID, { page_path: pagePath });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
